"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Direction = void 0;
var Direction;
(function (Direction) {
    Direction[Direction["North"] = 1] = "North";
    Direction[Direction["NorthEast"] = 2] = "NorthEast";
    Direction[Direction["SouthEast"] = 4] = "SouthEast";
    Direction[Direction["South"] = 8] = "South";
    Direction[Direction["SouthWest"] = 16] = "SouthWest";
    Direction[Direction["NorthWest"] = 32] = "NorthWest";
})(Direction = exports.Direction || (exports.Direction = {}));
(function (Direction) {
    function list() {
        return [Direction.North, Direction.NorthEast, Direction.SouthEast,
            Direction.South, Direction.SouthWest, Direction.NorthWest];
    }
    Direction.list = list;
    Direction.all = Direction.North | Direction.NorthEast | Direction.SouthEast | Direction.South | Direction.SouthWest | Direction.NorthWest;
})(Direction = exports.Direction || (exports.Direction = {}));
//# sourceMappingURL=direction.js.map